import React, { useState, useEffect } from 'react';
import { Chart } from 'primereact/chart';
import CreateAction from '../../../components/operational/createAction';
import { translate } from '../../../utils/language';

const AveragePurchaseRevenuePerUserChart = ({ dateRange }) => {
  const [chartData, setChartData] = useState({});
  const [datas, setDatas] = useState([]);
  const [totalValue, setTotalValue] = useState(0);
  const [chartOptions, setChartOptions] = useState({});
  const [errorMessage, setErrorMessage] = useState('');
  const [currencySymbol, setCurrencySymbol] = useState('');
  const getDatas = async () => {
    const response = await CreateAction({
      method: 'post',
      data: { dateRange },
      path: `/report/averagePurchaseRevenuePerUser`,
      showPreLoader: true,
      isFileUploading: false,
      hideToastMessages: true,
    });

    if (response?.error) return;

    if (response?.result?.resultData?.firebaseService === 'NEED_PERMISSION') {
      setErrorMessage('NEED_PERMISSION');
      return;
    }

    if (!response?.result?.resultData?.rows) return setErrorMessage('NO_DATA')
    setErrorMessage('');
    setCurrencySymbol(response?.result?.resultData?.metadata?.currencyCode);

    const resultData = Object.entries(response?.result?.resultData.rows || {}).map(([date, value]) => ({
      date,
      value: Number(value),
    }));


    if (resultData?.length === 1) {
      resultData.push(resultData[0])
    }

    const totalValue = resultData.reduce((acc, item) => acc + item.value, 0);
    setTotalValue(totalValue / resultData.length);
    setDatas(resultData || []);
  };

  useEffect(() => {
    if (dateRange.startDate && dateRange.endDate) getDatas();
  }, [dateRange]);

  useEffect(() => {
    const documentStyle = getComputedStyle(document.documentElement);
    const textColor = documentStyle.getPropertyValue('--text-color');
    const textColorSecondary = documentStyle.getPropertyValue('--text-color-secondary');
    const surfaceBorder = documentStyle.getPropertyValue('--surface-border');
    const chartRef = document.querySelector('.p-chart canvas');
    const chartContext = chartRef.getContext('2d');
    const gradient = chartContext.createLinearGradient(0, 0, 0, chartRef.height);
    gradient.addColorStop(0, 'rgb(112, 89, 239)');
    gradient.addColorStop(0.5, 'rgb(112, 89, 239,0)');
    const data = {
      labels: datas?.map(data => {
        return data.date
      }),
      datasets: [
        {
          label: `Ortalama Kullanıcı Başına Dönüşüm Değeri`,
          data: datas.map(data => data.value),
          fill: true,
          backgroundColor: gradient,
          borderColor: '#7059EF',

          tension: 0.4,
        },
      ],
    };
    const options = {
      maintainAspectRatio: false,
      aspectRatio: 1,
      plugins: {
        legend: {
          labels: {
            color: textColor,
            usePointStyle: true,
            pointStyle: 'circle',
            boxWidth: 8,
            boxHeight: 8,
            padding: 10,
          },
        },
      },
      scales: {
        x: {
          ticks: {
            color: textColorSecondary,
            maxTicksLimit: 6,
          },
          grid: {
            color: surfaceBorder,
          },
        },
        y: {
          ticks: {
            color: textColorSecondary,
            maxTicksLimit: 6,
          },
          grid: {
            color: surfaceBorder,
          },
        },
      },
    };

    setChartData(data);
    setChartOptions(options);
  }, [datas]);

  return (
    <div className="card">
      {errorMessage ? (
        <div className="p-2">
          <div className="text-[#494949] text-[17px]">Ortalama Kullanıcı Başına Dönüşüm Değeri</div>
          <div className="text-red-500 text-center py-4">
            {translate(errorMessage)}
          </div>
        </div>
      ) : (
        <>
          <div className="p-2">
            <div className="text-[#494949] text-[17px]">Ortalama Kullanıcı Başına Dönüşüm Değeri</div>
            <div className="text-[#494949] text-[27px]">
              {currencySymbol === 'USD' ? '$ ' : '₺ '}
              {totalValue?.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' '}
            </div>
          </div>
          <Chart type="line" data={chartData} options={chartOptions} />
        </>
      )}
    </div>
  );
};

export default AveragePurchaseRevenuePerUserChart;
